module.exports = __webpack_public_path__ + "gm992021/img/jianghu-1.png?36284e21";